
export interface InventoryProduct {
    total_inventory: number;
    group_buy_enabled?: boolean;
    liquidation_sale_enabled?: boolean;
    liquidation_current_inventory?: number;
    [key: string]: any; // Allow other properties
}

/**
 * Checks if a product is effectively out of stock.
 * Group Buy products are excluded from this check (never out of stock).
 * Liquidation products use their specific inventory if available.
 */
export const isOutOfStock = (product: InventoryProduct): boolean => {
    // Group Buy Exclusion
    if (product.group_buy_enabled) return false;

    const effectiveTotal = product.liquidation_sale_enabled
        ? (product.liquidation_current_inventory ?? product.total_inventory ?? 0)
        : (product.total_inventory ?? 0);

    return effectiveTotal <= 0;
};
